export function DemoBrushBadge() {
  return (
    <span className="relative inline-flex h-7 min-w-[76px] -rotate-[4deg] items-center justify-center px-3">
      <svg
        aria-hidden="true"
        className="absolute inset-0 size-full overflow-visible text-softiq-primary dark:text-softiq-secondary"
        viewBox="0 0 112 36"
        preserveAspectRatio="none"
      >
        <path
          d="M3 9 C15 5 26 7 39 4 C57 2 72 6 89 4 L108 8 L103 12 L110 15 L106 20 L109 25 C88 29 72 27 54 31 C37 33 20 28 5 31 L9 26 L2 24 L6 19 L1 15 Z"
          fill="currentColor"
        />
        <path
          d="M10 6 C34 2 70 5 100 3 M7 32 C35 35 72 31 103 33"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
          opacity="0.7"
        />
      </svg>
      <span className="relative z-10 text-[10px] font-bold uppercase tracking-[0.16em] text-white dark:text-softiq-primary">
        Demo
      </span>
    </span>
  );
}
